<template>
  <div class="login">
    <form @submit.prevent="onSubmit">
      <div class="form-group row" v-if="error.message">
        <div class="col">
          <div class="alert alert-warning">
            <strong>{{ error.message }}</strong><br>
            Bitte die Zugangsdaten prüfen.
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="login-username" class="col-sm-2 col-form-label">Benutzer</label>
        <div class="col offset-sm-1">
          <input type="text" ref="username" v-model="user.username"
            class="form-control" id="login-username" autofocus>
        </div>
      </div>
      <div class="form-group row">
        <label for="login-password" class="col-sm-2 col-form-label">Passwort</label>
        <div class="col offset-sm-1">
          <input type="password" v-model="user.password" class="form-control"
            id="login-password">
        </div>
      </div>
      <div class="form-group row">
        <div class="col offset-3">
          <button type="submit" class="btn btn-primary">Login</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auth from '../../services/auth'

export default {
  data () {
    return {
      user: {
        username: '',
        password: ''
      },
      error: {
        message: ''
      }
    }
  },

  methods: {
    onSubmit () {
      let { username, password } = this.user
      auth.login(username, password)
        .then(() => {
          this.error = {}
          this.$router.replace('/')
        })
        .catch((reason) => {
          if (reason instanceof Error) throw reason
          this.user.username = ''
          this.user.password = ''
          this.error.message = 'Login fehlgeschlagen'
          this.$refs.username.focus()
        })
    }
  }
}
</script>

<style scoped lang="scss">
  form {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// login.vue?3737cc7a